import {getStore} from "trim-redux";
import {translateKey} from "../values";
import {
    LayoutDashboard,
    Boxes,
    UsersRound,
    Store,
    ShoppingBag,
    Wallet,
    Settings,
    TicketPercent,
    Images,
    Paperclip,
    MapPinned,
    NotepadText,
    ShoppingCart,
    Box,
    MessageCircleMore,
    HeartHandshake,
    ClipboardList,
    StickyNote,
    ShapesIcon,
    Shapes,
    Bike, Headset, Handshake
} from "lucide-react";
import { CalendarClock, Grid2x2Check, Pen, ScrollText } from "lucide-react";

export const getRoutes = function () {
    return [
        {
            id: 'dashboard',
            title: translateKey('dashboard'),
            type: 'item',
            icon: <LayoutDashboard className="lucide-icon-sidebar"/>,
            url: '/panel/dashboard',
        },
        {
            id: 'manageOrders',
            title: translateKey('manageOrders'),
            type: 'item',
            url: '/panel/manage/orders',
            icon: <ClipboardList className="lucide-icon-sidebar"/>,
            exact:true,
            permission: 'manageSettings',
        },
        {
            id: 'support',
            title: translateKey('support'),
            type: 'item',
            url: '/panel/manage/support',
            icon: <Headset className="lucide-icon-sidebar"/>,
            exact:true,
            permission: 'manageSettings',
        },
        {
            id: 'manageCategories',
            title: translateKey('manageCategories'),
            type: 'item',
            url: '/panel/manage/categories/view-all',
            icon: <Shapes className="lucide-icon-sidebar"/>,
            exact:true,
            permission: 'manageSettings',
        },
        {
            id: 'usersList',
            title: translateKey('userslist'),
            type: 'item',
            url: '/panel/manage/users/view-all',
            icon: <UsersRound className="lucide-icon-sidebar"/>,
            exact:true,
            permission: 'manageSettings',
        },
        {
            id: 'shopsList',
            title: translateKey('shopsList'),
            type: 'item',
            url: '/panel/manage/shops/view-all',
            icon: <Store className="lucide-icon-sidebar"/>,
            exact:true,
            permission: 'manageSettings',
        },
        {
            id: 'couriersList',
            title: translateKey('couriersList'),
            type: 'item',
            url: '/panel/manage/couriers/view-all',
            icon: <Bike className="lucide-icon-sidebar"/>,
            exact:true,
            permission: 'manageSettings',
        },
        {
            id: 'marketingReps',
            title: translateKey('marketingRepsTitle'),
            type: 'item',
            url: '/panel/manage/marketing/reps',
            icon: <Handshake className="lucide-icon-sidebar"/>,
            exact:true,
            permission: 'manageSettings',
        },
        {
            id: 'marketingLeads',
            title: translateKey('marketingLeadsTitle'),
            type: 'item',
            url: '/panel/manage/marketing/leads',
            icon: <ClipboardList className="lucide-icon-sidebar"/>,
            exact:true,
            permission: 'manageSettings',
        },
        {
            id: 'manageProducts',
            title: translateKey('manageProducts'),
            type: 'item',
            url: '/panel/manage/products/view-all',
            icon: <ShoppingBag className="lucide-icon-sidebar"/>,
            exact:true,
            permission: 'manageSettings',
        },
        {
            id: 'discountCodes',
            title: translateKey('discountCodes'),
            type: 'item',
            url: '/panel/manage/discount-codes/view-all',
            icon: <TicketPercent className="lucide-icon-sidebar"/>,
            exact:true,
            permission: 'manageSettings',
        },
        {
            id: 'manageComments',
            title: translateKey('manageComments'),
            type: 'item',
            url: '/panel/manage/comments/view-all',
            icon: <MessageCircleMore className="lucide-icon-sidebar"/>,
            exact:true,
            permission: 'manageSettings',
        },
        {
            id: 'manageWallets',
            title: translateKey('manageWallets'),
            icon: <Wallet className="lucide-icon-sidebar"/>,
            permission: 'managePayments',
            type: 'item',
            url: '/panel/manage/wallets/view-all',
        },
        {
            id: 'iyzipayApprovals',
            title: translateKey('iyzipayApprovalsTitle'),
            icon: <Grid2x2Check className="lucide-icon-sidebar"/>,
            permission: 'managePayments',
            type: 'item',
            url: '/panel/manage/iyzipay-approvals',
            exact: true,
        },
        {
            id: 'vendorSettlements',
            title: translateKey('vendorSettlementsTitle'),
            icon: <ScrollText className="lucide-icon-sidebar"/>,
            permission: 'managePayments',
            type: 'item',
            url: '/panel/manage/vendor-settlements',
            exact: true,
        },
        {
            id: 'eInvoices',
            title: translateKey('eInvoicesTitle'),
            icon: <NotepadText className="lucide-icon-sidebar"/>,
            permission: 'managePayments',
            type: 'item',
            url: '/panel/manage/einvoices',
            exact: true,
        },
        {
            id: 'changeSettings',
            title: translateKey('changeSettings'),
            type: 'item',
            icon: <Settings className="lucide-icon-sidebar"/>,
            url: '/panel/manage/setting/view-all',
            roles: ['admin'],
            permission: "manageSettings",
        },
        /*{
            id: 'manageCharities',
            title: translateKey('manageCharities'),
            type: 'item',
            url: '/panel/manage/charities/view-all',
            icon: <HeartHandshake className="lucide-icon-sidebar"/>,
            exact:true,
            permission: 'manageSettings',
        },*/
        {
            id: 'managePages',
            title: translateKey('managePages'),
            type: 'item',
            icon: <StickyNote className="lucide-icon-sidebar"/>,
            url: '/panel/manage/pages/view-all',
            roles: ['admin'],
            permission: "manageSettings",
        },
        {
            id: 'manageBanners',
            title: translateKey('manageBanners'),
            type: 'item',
            icon: <Images className="lucide-icon-sidebar"/>,
            url: '/panel/manage/setting/banners',
            roles: ['admin'],
            permission: "manageSettings",
        },
        {
            id: 'fileManager',
            title: translateKey('fileManager'),
            type: 'item',
            icon: <Paperclip className="lucide-icon-sidebar"/>,
            url: '/panel/file-manager',
            roles: ['admin'],
            permission: "manageSettings",
        },
        {
            id: 'shop',
            title: translateKey('ordersList'),
            type: 'item',
            icon: <ClipboardList className="lucide-icon-sidebar"/>,
            url: '/panel/vendor/orders',
            roles: ['supplier'],
        },
        {
            id: 'products',
            title: translateKey('productsList'),
            type: 'item',
            icon: <ShoppingBag className="lucide-icon-sidebar"/>,
            url: '/panel/vendor/products/view-all',
            roles: ['supplier'],
        },
        {
            id: 'shop',
            title: translateKey('yourInfo'),
            type: 'item',
            icon: <Store className="lucide-icon-sidebar"/>,
            url: '/panel/vendor/setting/details',
            roles: ['supplier'],
        },
        {
            id: 'shop',
            title: translateKey('address'),
            type: 'item',
            icon: <MapPinned className="lucide-icon-sidebar"/>,
            url: '/panel/vendor/setting/address',
            roles: ['supplier'],
        },
        {
            id: 'shopCategories',
            title: translateKey('categories'),
            type: 'item',
            icon: <Shapes className="lucide-icon-sidebar"/>,
            url: '/panel/vendor/setting/categories',
            roles: ['supplier'],
            disabled: !getStore('user')?.shop?.id
        },
        {
            id: 'menus',
            title: translateKey('menus'),
            type: 'item',
            icon: <ScrollText className="lucide-icon-sidebar"/>,
            url: '/panel/vendor/setting/menus',
            roles: ['supplier'],
            disabled: !getStore('user')?.shop?.id
        },
        {
            id: 'shopHours',
            title: translateKey('workHours'),
            type: 'item',
            icon: <CalendarClock className="lucide-icon-sidebar"/>,
            url: '/panel/vendor/setting/hours',
            roles: ['supplier'],
            disabled: !getStore('user')?.shop?.id
        },
        {
            id: 'wallets',
            title: translateKey('myTransactions'),
            icon: <Wallet className="lucide-icon-sidebar"/>,
            type: 'item',
            url: '/panel/vendor/wallet',
            roles: ['supplier'],
        },
    ]
}

